import React from 'react'
import '../../App.css'
import Footer from '../Footer'
import Infopage from '../Infopage'

function Info() {
    return (
        <> 
          <Infopage/> 
          <Footer/>
        </>
    )
}

export default Info